import { computed, type Ref } from 'vue'
import type { Swiper } from 'swiper/types'
import { useOverviewStore } from '../../stores/overview'

export function useListOverview(swiperRef: Ref<Swiper | undefined>) {
  const overviewStore = useOverviewStore()

  const activePage = computed(() => overviewStore.page)
  const slideIndex = computed(() => overviewStore.slide)

  function hasHighlight(page: number) {
    return page == activePage.value
  }

  function doSelectPage(page: number) {
    overviewStore.setActivePage(page)
    overviewStore.showSamudkoyContent()      
  }

  function doUpdateSlide(index: number) {
    overviewStore.slideTo(index)
  }

  return {
    slideIndex,
    hasHighlight,
    doUpdateSlide,
    doSelectPage,
  }
}
